export function mergeConfigs(defaults: any, template: any, tenantOverride: any): any {
  return {
    ...defaults,
    ...(template || {}),
    ...(tenantOverride || {}),
  };
}

export const defaultThemeConfig = {
  primaryColor: '#3B82F6',
  darkMode: false,
  sidebarCollapsed: false,
};
